import React from 'react';

import Box from '@mui/material/Box';
import Drawer, { DrawerProps } from '@mui/material/Drawer';
import IconButton, { IconButtonProps } from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';

import { Icon } from '../icon';

export type { DrawerProps };
export { Drawer };

const MySideDrawerTitle = ({
  title,
  onClick,
}: {
  title: string;
  onClick: IconButtonProps['onClick'];
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderBottom: `1px solid ${theme.colors.secondary.lighter}`,
        pt: 3,
        pb: 2,
        pl: 5,
        pr: 6,
      }}
    >
      <Typography fontWeight="bold">{title}</Typography>
      <IconButton
        size="small"
        color="primary"
        onClick={onClick}
        sx={{ border: `1px solid ${theme.colors.secondary.lighter}` }}
      >
        <Icon
          name={'Close'}
          iconProps={{ color: 'error', fontSize: 'small' }}
        />
      </IconButton>
    </Box>
  );
};

export { MySideDrawerTitle };
